import { useSyncExternalStore } from 'react';

export type NetworkStatus = 'online' | 'offline' | 'server_unreachable';

let serverReachable = true;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((fn) => fn());
}

if (typeof window !== 'undefined') {
  window.addEventListener('online', emit);
  window.addEventListener('offline', emit);
}

export function setServerReachable(reachable: boolean): void {
  if (serverReachable === reachable) return;
  serverReachable = reachable;
  emit();
}

export function getNetworkStatus(): NetworkStatus {
  if (typeof navigator !== 'undefined' && !navigator.onLine) return 'offline';
  if (!serverReachable) return 'server_unreachable';
  return 'online';
}

export function subscribeNetworkStatus(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

/** Test hook. */
export function _clearNetworkStatus(): void {
  serverReachable = true;
  listeners.clear();
}

export function useNetworkStatus(): NetworkStatus {
  return useSyncExternalStore(subscribeNetworkStatus, getNetworkStatus, getNetworkStatus);
}
